import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { PageTitle } from '@/components/molecules/PageTitle';
import { Typography } from '@/components/atoms/Typography';
import { useCheckClaimTokenQuery } from '@/api/hooks/useClaim';

export const ClaimCheckPage = () => {
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const token = params.get('token');

  const { data: tokenData, isLoading: loadingToken } = useCheckClaimTokenQuery(token || '');

  useEffect(() => {
    if (tokenData && tokenData.redirectUrl) {
      navigate(tokenData.redirectUrl);
    }
  }, [tokenData, navigate]);

  return (
    <div className="h-screen w-full mx-auto bg-yellow-50">
      <div className="max-w-6xl mx-auto">
        <PageTitle firstTitle="Vérification de la demande de transfert" />
      </div>

      <div className="m-auto flex items-center text-center mt-10 justify-center flex-col bg-yellow-200 w-fit py-5 px-10 rounded-lg">
        <Typography>Vérification en cours de vos données...</Typography>
      </div>
    </div>
  );
};
